export default __webpack_public_path__ + "icons/safari-pinned-tab-9e952c306602ccd40701a826a6206404.svg";